/* sg-pdp-explore: mezcla los candidatos al azar, muestra la cantidad elegida y mueve el carrusel con las flechas. */
if (!customElements.get('sg-explore')) {
  class SgExplore extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-sg-ex-track]');
      if (!this.track) return;
      this.count = parseInt(this.dataset.count, 10) || 7;
      if (this.dataset.shuffle !== 'false') this.shuffle();
      this.show();
      this.initArrows();
      if (this.dataset.shuffle !== 'false') this.pickRandom();
    }

    /* Elige productos al azar entre TODO el catálogo: cada uno tiene la misma probabilidad. Se piden por posición
       (?view=random&page=N devuelve el producto N de la colección); si alguno no está disponible se prueba otra posición. */
    async pickRandom() {
      const total = parseInt(this.dataset.total, 10) || 0;
      if (total < 1) return;
      const base = (this.dataset.root || '/').replace(/\/?$/, '/');
      const url = (n) => `${base}collections/${this.dataset.source || 'all'}?view=${this.dataset.view || 'random'}&page=${n}`;
      const extra = parseInt(this.dataset.extra, 10) || 0;
      const parallel = Math.max(1, parseInt(this.dataset.parallel, 10) || 3); // peticiones a la vez: pocas, para no saturar la tienda
      const tried = new Set();
      const found = [];
      const ids = new Set([String(this.dataset.self || '')]);

      const one = async (n) => {
        try {
          const res = await fetch(url(n), { headers: { Accept: 'text/html' } });
          if (!res.ok) return null;
          const tpl = document.createElement('template');
          tpl.innerHTML = await res.text();
          return tpl.content.querySelector('li[data-product-id]');
        } catch (err) {
          return null;
        }
      };

      /* Hasta 3 rondas: cada una pide lo que falta más los intentos extra, con posiciones distintas */
      for (let round = 0; round < 3 && found.length < this.count && tried.size < total; round += 1) {
        const want = Math.min(this.count - found.length + extra, total - tried.size);
        const batch = [];
        while (batch.length < want) {
          const n = 1 + Math.floor(Math.random() * total);
          if (!tried.has(n)) { tried.add(n); batch.push(n); }
        }
        /* Las posiciones se piden en grupos pequeños; si ya hay suficientes, no se piden más */
        for (let i = 0; i < batch.length && found.length < this.count; i += parallel) {
          // eslint-disable-next-line no-await-in-loop
          const lis = await Promise.all(batch.slice(i, i + parallel).map(one));
          lis.forEach((li) => {
            if (li && !ids.has(li.dataset.productId) && found.length < this.count) {
              ids.add(li.dataset.productId);
              found.push(li);
            }
          });
        }
      }

      if (found.length < Math.min(this.count, 3)) return; // muy pocos: se queda el respaldo del servidor
      found.forEach((li) => { li.hidden = false; });
      this.track.replaceChildren(...found);
      this.track.scrollLeft = 0;
      this.dataset.sgSource = 'random';
      this.initArrows();
    }

    /* Fisher-Yates sobre los <li>; el DOM se reordena una sola vez */
    shuffle() {
      const items = [...this.track.children];
      for (let i = items.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [items[i], items[j]] = [items[j], items[i]];
      }
      items.forEach((li) => this.track.appendChild(li));
    }

    show() {
      [...this.track.children].forEach((li, i) => { li.hidden = i >= this.count; });
    }

    initArrows() {
      const prev = this.querySelector('[data-sg-ex-prev]');
      const next = this.querySelector('[data-sg-ex-next]');
      if (!prev || !next) return;
      if (this.arrowsReady) { this.syncArrows(); return; }
      this.arrowsReady = true;
      const step = () => {
        const first = this.track.querySelector('.sg-ex__item:not([hidden])');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return first ? first.getBoundingClientRect().width + gap : this.track.clientWidth;
      };
      const sync = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        prev.disabled = this.track.scrollLeft <= 2;
        next.disabled = this.track.scrollLeft >= max;
      };
      this.syncArrows = sync;
      prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      this.track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }
  customElements.define('sg-explore', SgExplore);
}
